import useAxios from "utils/useAxios";

const POWERTRADING_BASE_URL = `/trading/clients/`;
const COMMUNITIES_BASE_URL = `/community-management/clients/`;
const CORE_BASE_URL = `/core/clients/`;

export const useClientsAPI = () => {

    const { api, nonCachedRequest } = useAxios();

    const get = (id) => {
        if (!id) {
            throw new Error("id is mandatory");
        }

        return api.get(CORE_BASE_URL + id);
    }

    const remove = (id) => {
        if (!id) {
            throw new Error("id is mandatory");
        }

        return api.delete(CORE_BASE_URL + id);
    }

    const getAutoInvoiceAgreements = (id) => {
        if (!id) {
            throw new Error("id is mandatory");
        }

        return api.get(`${CORE_BASE_URL}${id}/auto_invoice_agreements/`);
    }

    const createAutoInvoiceAgreement = (id, agentEntityId) => {
        if (!id) {
            throw new Error("id is mandatory");
        }

        if (!agentEntityId) {
            throw new Error("agentEntityId is mandatory");
        }

        return api.post(`${CORE_BASE_URL}${id}/auto_invoice_agreement/`, { "agent_entity_id": agentEntityId, "has_validation_code": false, "is_auto_invoice": true });
    }

    const updateAutoInvoiceAgreement = (entityId, data) => {
        if (!entityId) {
            throw new Error("entityId is mandatory");
        }
        return api.patch(`${CORE_BASE_URL}${entityId}/auto_invoice_agreement/`, data)
    }

    const deleteAutoInvoiceAgreement = (entityId, agentEntityId) => {
        return api.patch(`${CORE_BASE_URL}${entityId}/auto_invoice_agreement/`, { agent_entity_id: agentEntityId, active: false });
    }

    const getPaymentMethods = (id) => {
        if (!id) {
            throw new Error("id is mandatory");
        }

        return api.get(`${CORE_BASE_URL}${id}/payment_methods/`);
    }

    const getClientPaymentMethods = (id, agentEntityID) => {
        if (!id) {
            throw new Error("id is mandatory");
        }

        return api.get(`${CORE_BASE_URL}${id}/payment_methods/?agent_entity_id=${agentEntityID}`);
    }

    const createPaymentMethod = (entityId, agentEntityId, method, ddIban, ddMandateReference, ddMaxValue) => {
        if (!entityId) {
            throw new Error("entityId is mandatory");
        }

        if (!agentEntityId) {
            throw new Error("agentEntityId is mandatory");
        }

        if (!method) {
            throw new Error("method is mandatory");
        }

        return api.post(`${CORE_BASE_URL}${entityId}/payment_method/`, {
            agent_entity_id: agentEntityId,
            method,
            dd_iban: ddIban === "" ? null : ddIban,
            dd_mandate_reference: ddMandateReference === "" ? null : ddMandateReference,
            dd_max_value: ddMaxValue === "" ? null : ddMaxValue
        })
    }

    const updatePaymentMethod = (entityId, agentEntityId, method, ddIban, ddMandateReference, ddMaxValue) => {
        if (!entityId) {
            throw new Error("entityId is mandatory");
        }

        if (!agentEntityId) {
            throw new Error("agentEntityId is mandatory");
        }

        if (!method) {
            throw new Error("method is mandatory");
        }

        return api.patch(`${CORE_BASE_URL}${entityId}/payment_method/`, { agent_entity_id: agentEntityId, method, dd_iban: ddIban, dd_mandate_reference: ddMandateReference, dd_max_value: ddMaxValue })
    }

    const deletePaymentMethod = (entityId, agentEntityId) => {
        return api.patch(`${CORE_BASE_URL}${entityId}/payment_method/`, { agent_entity_id: agentEntityId, active: false });
    }

    const fetchCommunityClients = (filters = [], page_size = 10, page = 1, sortColumns, callBack, errorCallBack) => {
        let url = COMMUNITIES_BASE_URL + `?page_size=${page_size}&page=${page}`;
        filters.map((filter) => {
            url += `&${filter.id.replace('.', '__')}=${filter.value}`;
        });

        if (sortColumns) {
            url += `&ordering=${sortColumns}`
        }

        nonCachedRequest(url, callBack, errorCallBack);
    };

    const fetchClients = (filters = [], page_size = 10, page = 1, sortColumns, callBack, errorCallBack) => {
        let url = CORE_BASE_URL + `?page_size=${page_size}&page=${page}`;
        filters.map((filter) => {
            url += `&${filter.id.replace(/\./g, '__')}=${filter.value}`;
        });

        if (sortColumns) {
            url += `&ordering=${sortColumns}`
        }

        nonCachedRequest(url, callBack, errorCallBack);
    };

    const fetch = (filters = [], page_size = 10, page = 1, sortColumns, callBack, errorCallBack) => {
        let url = POWERTRADING_BASE_URL + `?page_size=${page_size}&page=${page}`;
        filters.map((filter) => {
            url += `&${filter.id.replace('.', '__')}=${filter.value}`;
        });

        if (sortColumns) {
            url += `&ordering=${sortColumns}`
        }

        nonCachedRequest(url, callBack, errorCallBack);
    };

    const fetchById = (id, callBack, errorCallBack) => {
        if (!id || id == null) {
            return;
        }
        nonCachedRequest(`${POWERTRADING_BASE_URL}${id}`, callBack, errorCallBack);
    }

    const save = (values, callBack, errorCallBack) => {
        api.post(POWERTRADING_BASE_URL, values).then((response) => {
            callBack(response);
        }).catch((e) => {
            errorCallBack(e);
        })
    };

    const update = (id, values) => {
        return api.patch(CORE_BASE_URL + id + "/", values);
    };

    const contracts = (id, filters, callBack, errorCallBack) => {
        let url = `${POWERTRADING_BASE_URL}${id}/contracts/`;
        filters.map((filter) => {
            url += `&${filter.id.replace('.', '__')}=${filter.value}`;
        });
        nonCachedRequest(url, callBack, errorCallBack)
    }

    const communities = (id, filters = [], page_size = 10, page = 1, sortColumns, callBack, errorCallBack) => {
        let url = `${CORE_BASE_URL}${id}/communities?page_size=${page_size}&page=${page}`;

        filters.map((filter) => {
            url += `&${filter.id.replace('.', '__')}=${filter.value}`;
        });

        if (sortColumns) {
            url += `&ordering=${sortColumns}`
        }

        nonCachedRequest(url, callBack, errorCallBack);
    };

    const physicalUnits = (id, filters = [], page_size = 10, page = 1, sortColumns, callBack, errorCallBack) => {
        let url = `${CORE_BASE_URL}${id}/physical_units?page_size=${page_size}&page=${page}`;

        filters.map((filter) => {
            url += `&${filter.id.replace('.', '__')}=${filter.value}`;
        });

        if (sortColumns) {
            url += `&ordering=${sortColumns}`
        }

        nonCachedRequest(url, callBack, errorCallBack);
    };

    const getAllFinancialDocuments = (id, filters = [], page_size = 10, page = 1, sortColumns, callBack, errorCallBack) => {
        let url = `${CORE_BASE_URL}${id}/financial_documents?page_size=${page_size}&page=${page}`;

        filters.map((filter) => {
            url += `&${filter.id.replace('.', '__')}=${filter.value}`;
        });

        if (sortColumns) {
            url += `&ordering=${sortColumns}`
        }

        nonCachedRequest(url, callBack, errorCallBack);
    }

    const getReceivedFinancialDocuments = (id, filters = [], page_size = 10, page = 1, sortColumns, callBack, errorCallBack) => {
        let url = `${CORE_BASE_URL}${id}/sales_documents?page_size=${page_size}&page=${page}`;

        filters.map((filter) => {
            url += `&${filter.id.replace('.', '__')}=${filter.value}`;
        });

        if (sortColumns) {
            url += `&ordering=${sortColumns}`
        }

        nonCachedRequest(url, callBack, errorCallBack);
    }

    const getIssuedFinancialDocuments = (id, filters = [], page_size = 10, page = 1, sortColumns, callBack, errorCallBack) => {
        let url = `${CORE_BASE_URL}${id}/purchase_documents?page_size=${page_size}&page=${page}`;

        filters.map((filter) => {
            url += `&${filter.id.replace('.', '__')}=${filter.value}`;
        });

        if (sortColumns) {
            url += `&ordering=${sortColumns}`
        }

        nonCachedRequest(url, callBack, errorCallBack);
    }

    const getAgentCostsDocuments = (id, filters = [], page_size = 10, page = 1, sortColumns, callBack, errorCallBack) => {
        let url = `${CORE_BASE_URL}${id}/agent_costs_documents?page_size=${page_size}&page=${page}`;

        filters.map((filter) => {
            url += `&${filter.id.replace('.', '__')}=${filter.value}`;
        });

        if (sortColumns) {
            url += `&ordering=${sortColumns}`
        }

        nonCachedRequest(url, callBack, errorCallBack);
    }

    const surplusCommunities = (id, filters = [], page_size = 30, page = 1, sortColumns, callBack, errorCallBack) => {
        let url = `${CORE_BASE_URL}${id}/surplus_communities?page_size=${page_size}&page=${page}`;

        filters.map((filter) => {
            url += `&${filter.id.replace('.', '__')}=${filter.value}`;
        });

        if (sortColumns) {
            url += `&ordering=${sortColumns}`;
        }

        nonCachedRequest(url, callBack, errorCallBack);
    };

    const sendRegistrationEmail = (id) => {
        if (!id) {
            throw new Error("id is mandatory");
        }

        return api.post(`${CORE_BASE_URL}${id}/send_registration_email/`);
    }

    const list = async ({ name, fiscal_number, page = 1, page_size = 10 } = {}) => {
        let url = `${CORE_BASE_URL}?page=${page}&page_size=${page_size}`;

        if (name) {
            url += `&name=${encodeURIComponent(name)}`;
        }

        if (fiscal_number) {
            url += `&fiscal_number=${encodeURIComponent(fiscal_number)}`;
        }

        const response = await api.get(url);
        return response.data;
    };

    return {
        get,
        remove,
        fetchCommunityClients,
        fetchClients,
        fetch,
        fetchById,
        save,
        update,
        contracts,
        getAutoInvoiceAgreements,
        createAutoInvoiceAgreement,
        updateAutoInvoiceAgreement,
        deleteAutoInvoiceAgreement,
        getPaymentMethods,
        getClientPaymentMethods,
        createPaymentMethod,
        updatePaymentMethod,
        deletePaymentMethod,
        communities,
        physicalUnits,
        surplusCommunities,
        getReceivedFinancialDocuments,
        getIssuedFinancialDocuments,
        getAgentCostsDocuments,
        sendRegistrationEmail,
        list,
        getAllFinancialDocuments
    }
};

